angular.module("digitalLeasing.module").component("resolutionNuovoPrestoLeasing", {
    templateUrl: "ng/components/digitalLeasing/resolutionNuovoPrestoLeasing/resolutionNuovoPrestoLeasing.view.html",
    bindings: {
      model: "=",
      validatePage: "&",
      invalidatePage: "&"
    },
    controllerAs: "resolutionNuovoPrestoLeasingCtrl",
    controller: function resolutionNuovoPrestoLeasing() {
      var self = this;
  

      self.$onInit = function () {

        self.model = self.model;
        console.log("model", self.model);

        self.printBackground = true;
      };

      self.exportValidityGuarantee = function(validation) {
        if(validation) {
          self.toggleDatePicker = true;
        } else {
          self.toggleDatePicker = false;
        }
      }

      self.check = function(validation, mode) {
        if(validation && mode === 'BV') {
          self.model.setModeBankVerification = true;
          self.validatePage();
        } else if(validation && mode === 'R') {
          self.model.setModeBankVerification = false;
          self.validatePage();
        } else {
          self.invalidatePage();
        }
      }

    }, 
  });